export default {
  GASP8: 'P-8',
  GASP13: 'P-13',
  GASP20: 'P-20',
  GASP45: 'P-45',
};



// WEBPACK FOOTER //
// ../utils/labels/products.js